import React from "react";
import { useTranslation } from "react-i18next";
import { Settings } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../ui/card";
import { Input } from "../../../ui/input";
import { Label } from "../../../ui/label";
import { Switch } from "../../../ui/switch";

const TunisiaBonusesCard = ({ formData, handleInputChange }) => {
  const { t } = useTranslation();
  return (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Settings className="h-5 w-5" />
        {t("payrollTN.bonusTitle")}
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <Label>{t("payrollTN.eidLabel")}</Label>
          <p className="text-sm text-muted-foreground">
            {t("payrollTN.eidHint")}
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Input
            type="number"
            min="0"
            value={formData.eid_bonus_amount}
            onChange={(e) => handleInputChange("eid_bonus_amount", parseFloat(e.target.value))}
            className="w-24"
            disabled={!formData.enable_eid_bonus}
          />
          <span className="text-sm text-muted-foreground">TND</span>
          <Switch
            checked={formData.enable_eid_bonus}
            onCheckedChange={(checked) => handleInputChange("enable_eid_bonus", checked)}
          />
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label>{t("payrollTN.month13")}</Label>
          <p className="text-sm text-muted-foreground">
            {t("payrollTN.month13Hint")}
          </p>
        </div>
        <Switch
          checked={formData.enable_13th_month}
          onCheckedChange={(checked) => handleInputChange("enable_13th_month", checked)}
        />
      </div>
    </CardContent>
  </Card>
  );
};

export default TunisiaBonusesCard;
